import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";

/**
 * Ouvre une URL dans le navigateur externe du système (app native) ou dans un
 * nouvel onglet (web). Utilisé notamment pour sortir de l'app iOS afin de
 * gérer un abonnement sur le web (pas d'achat d'abonnement in-app — règle Apple).
 */
export const openExternal = async (url: string): Promise<void> => {
  try {
    if (Capacitor.isNativePlatform()) {
      await Browser.open({ url });
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  } catch {
    try {
      window.open(url, "_blank", "noopener,noreferrer");
    } catch {
      /* ignore */
    }
  }
};
